import { createContext, PropsWithChildren, useContext } from 'react';

interface ResponsiveMenuContextProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ResponsiveMenuContext = createContext<ResponsiveMenuContextProps>({
  isOpen: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose: () => {},
});

export const useResponsiveMenuContext = () => {
  const context = useContext(ResponsiveMenuContext);

  if (!context) {
    throw new Error('useResponsiveMenuContext must be used within a ResponsiveMenuProvider');
  }

  return context;
};

export const ResponsiveMenuProvider = ({
  isOpen,
  onClose,
  children,
}: PropsWithChildren<ResponsiveMenuContextProps>) => (
  <ResponsiveMenuContext.Provider value={{ isOpen, onClose }}>
    {children}
  </ResponsiveMenuContext.Provider>
);
